<template>
  <div class="home">
    <div class="title">
      <img class="bg-img" src="../assets/img/title/data-analysis.png" />
      <!-- 天气 -->
      <div class="weather flex-y-center">
        <div class="w-icon flex-center">
          <img class="w-img" :src="weatherIcon[nowWeather.icon]" />
        </div>
        <div class="w-txt">
          <span>{{ nowWeather.temp || '暂无' }}</span>
          <span v-if="nowWeather.temp" class="s">℃</span>
          <span v-if="nowWeather.text" class="info">{{ nowWeather.text }}/{{ nowWeather.dew }}℃~{{ nowWeather.temp }}℃/风力{{ nowWeather.windScale }}级/湿度{{ nowWeather.humidity }}%</span>
        </div>
      </div>
      <!-- 时间 -->
      <div class="time flex-x-center">
        <div class="date flex-x-center">
          <div class="t">星期{{ dayStr }}</div>
          <div class="d">{{ this.dateStr }}</div>
        </div>
        <div class="time-info flex-y-center">{{ timeStr }}</div>
        <div class="login-state flex-center" @click="closePage">
          <img class="l-img" src="../assets/img/login/normal.png" />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="n-part">
        <agricultural-products></agricultural-products>
        <agricultural-rank class="mgn-top-70"></agricultural-rank>
        <library class="mgn-top-70"></library>
      </div>
      <div class="item2">
        <div class="title-part flex-y-center">
          <div class="t-item flex-y-center" @click="switchState(4)">
            <img v-if="getAll" class="i-img" src="../assets/img/select/ac-checked.png" />
            <img v-else class="i-img" src="../assets/img/select/nor-checked.png" />
            <span>全部</span>
          </div>
          <div class="t-item flex-y-center" @click="switchState(1)">
            <img v-if="cdState" class="i-img" src="../assets/img/select/ac-checked.png" />
            <img v-else class="i-img" src="../assets/img/select/nor-checked.png" />
            <img class="i-img" src="../assets/img/chandi.png" />
            <span>产地</span>
            <span v-if="this.showDNum" class="i-num">{{ this.showDNum[0] || 0 }}</span>
          </div>
          <div class="t-item flex-y-center" @click="switchState(2)">
            <img v-if="xdState" class="i-img" src="../assets/img/select/ac-checked.png" />
            <img v-else class="i-img" src="../assets/img/select/nor-checked.png" />
            <img class="i-img" src="../assets/img/xiaodi.png" />
            <span>销地</span>
            <span v-if="this.showDNum" class="i-num">{{ this.showDNum[1] || 0 }}</span>
          </div>
          <div class="t-item flex-y-center" @click="switchState(3)">
            <img v-if="jsdState" class="i-img" src="../assets/img/select/ac-checked.png" />
            <img v-else class="i-img" src="../assets/img/select/nor-checked.png" />
            <img class="i-img" src="../assets/img/jisandi.png" />
            <span>集散地</span>
            <span v-if="this.showDNum" class="i-num">{{ this.showDNum[2] || 0 }}</span>
          </div>
          <div class="t-select1">
            <select-box :sty="true" :list="addrData" :item="selItem" @sel="selEvent" keyword="code"></select-box>
          </div>
        </div>
        <div id="mapData" ref="mapData" :key="mapKey" style="width: 100%; height: 100%"></div>
      </div>
      <div class="n-part">
        <latest-quotation></latest-quotation>
        <skills-classroom class="mgn-top-70"></skills-classroom>
      </div>
    </div>
  </div>
</template>

<script>
  import * as echarts from "echarts";
  import "echarts-amap";
  import mapTagCd from "@/assets/img/map-tag-cd.png";
  import mapTagXd from "@/assets/img/map-tag-xd.png";
  import mapTagJsd from "@/assets/img/map-tag-jsd.png";
  import chandi from "@/assets/img/chandi.png";
  import xiaodi from "@/assets/img/xiaodi.png";
  import jisandi from "@/assets/img/jisandi.png";

  import { getBazaarData } from "@/api/index";

  import amQing from "../assets/img/weather/am-qing.png";
  import amDuoyun from "../assets/img/weather/am-duoyun.png";
  import pmQing from "../assets/img/weather/pm-qing.png";
  import pmDuoyun from "../assets/img/weather/pm-duoyun.png";
  import rain1 from "../assets/img/weather/rain1.png";
  import rain2 from "../assets/img/weather/rain2.png";
  import rain3 from "../assets/img/weather/rain3.png";
  import rain4 from "../assets/img/weather/rain4.png";
  import rain5 from "../assets/img/weather/rain5.png";
  import rain6 from "../assets/img/weather/rain6.png";
  import rain7 from "../assets/img/weather/rain7.png";
  import rain8 from "../assets/img/weather/rain8.png";
  import rain9 from "../assets/img/weather/rain9.png";
  import rain10 from "../assets/img/weather/rain10.png";
  import rain11 from "../assets/img/weather/rain11.png";
  import rain12 from "../assets/img/weather/rain12.png";
  import rain13 from "../assets/img/weather/rain13.png";
  import rain14 from "../assets/img/weather/rain14.png";
  import rain15 from "../assets/img/weather/rain15.png";
  import rain16 from "../assets/img/weather/rain16.png";
  import snow1 from "../assets/img/weather/snow1.png";
  import snow2 from "../assets/img/weather/snow2.png";
  import snow3 from "../assets/img/weather/snow3.png";
  import snow4 from "../assets/img/weather/snow4.png";
  import snow5 from "../assets/img/weather/snow5.png";
  import snow6 from "../assets/img/weather/snow6.png";
  import chen from "../assets/img/weather/chen.png";
  import mai from "../assets/img/weather/mai.png";
  import nodata from "../assets/img/weather/no.png";
  import shachen from "../assets/img/weather/shachen.png";
  import wu from "../assets/img/weather/wu.png";
  import yangsha from "../assets/img/weather/yangsha.png";
  import yin from "../assets/img/weather/yin.png";
  import autofit from "autofit.js";
  export default {
    name: 'Home',
    data() {
      return {
        mapObj: null, 
        markers: [],

        timeStr: '',
        dateStr: '',
        dayStr: '',
        cdState: true,
        xdState: true,
        jsdState: true,
        showDNum: null,

        mapKey: new Date().getTime(),
        addrVal: '',
        // 0:产地 1：销地 2：集散地

        selItem: {name: '北京市', code: '110000', center: [116.3, 40.21], zIndex: 9.2},
        createMapItem: {},
        addrData: [
          {name: '北京市', code: '110000', center: [116.3, 40.21], zIndex: 9.2},
          {name: '天津市', code: '120000', center: [117.43, 39.41], zIndex: 9.2},
          {name: '河北省', code: '130000', center: [115.8, 39.6], zIndex: 7.2},
          {name: '山西省', code: '140000', center: [112.5, 37.8], zIndex: 7.2},
          {name: '内蒙古自治区', code: '150000', center: [111.46, 44.85], zIndex: 5.6},
          {name: '辽宁省', code: '210000', center: [122.24, 41.11], zIndex: 7.6},
          {name: '吉林省', code: '220000', center: [126.3345, 43.886841], zIndex: 7.2},
          {name: '黑龙江省', code: '230000', center: [128.642464, 48.986967], zIndex: 6.4},
          {name: '上海市', code: '310000', center: [121.472644, 31.231706], zIndex: 9.8},
          {name: '江苏省', code: '320000', center: [118.8062, 33.0304], zIndex: 7.8},
          {name: '浙江省', code: '330000', center: [120.1592484, 29.265995], zIndex: 7.8},
          {name: '安徽省', code: '340000', center: [117.10, 31.91], zIndex: 7.8},
          {name: '福建省', code: '350000', center: [119.18, 26.05], zIndex: 7.8},
          {name: '江西省', code: '360000', center: [115.27, 27.45], zIndex: 7.8},
          {name: '山东省', code: '370000', center: [118.02, 36.39], zIndex: 7.8},
          {name: '河南省', code: '410000', center: [113.44, 34.1], zIndex: 7.8},
          {name: '湖北省', code: '420000', center: [112.30, 30.38], zIndex: 7.4},
          {name: '湖南省', code: '430000', center: [111.53, 27.6], zIndex: 7.8},
          {name: '广东省', code: '440000', center: [113.32, 23.06], zIndex: 7.8},
          {name: '广西壮族自治区', code: '450000', center: [108.21, 24.1], zIndex: 7.8},
          {name: '海南省', code: '460000', center: [109.6, 19.03], zIndex: 9.2},
          {name: '重庆市', code: '500000', center: [107.53, 29.41], zIndex: 8.6},
          {name: '四川省', code: '510000', center: [103.68, 30.45], zIndex: 6.9},
          {name: '贵州省', code: '520000', center: [106.7134, 26.578343], zIndex: 7.8},
          {name: '云南省', code: '530000', center: [102.42, 25.04], zIndex: 7.2},
          {name: '西藏自治区', code: '540000', center: [89.13, 29.86], zIndex: 6.2},
          {name: '陕西省', code: '610000', center: [108.94, 33.86], zIndex: 7.2},
          {name: '甘肃省', code: '620000', center: [103.82159, 35.54422], zIndex: 7.1},
          {name: '青海省', code: '630000', center: [96.678979, 36.423901], zIndex: 6.6},
          {name: '宁夏回族自治区', code: '640000', center: [106.27401, 37.169828], zIndex: 7.8},
          {name: '新疆维吾尔自治区', code: '650000', center: [87.384019, 42.626934], zIndex: 5.7},
          {name: '台湾', code: '710000', center: [121.55, 23.4450], zIndex: 8.2},
          {name: '香港特别行政区', code: '810000', center: [114.2, 22.4], zIndex: 10.8},
          {name: '澳门特别行政区', code: '820000', center: [113.5555, 22.15555], zIndex: 13.2}
        ],
        // key: 'ede022eee7da4a09b8eee38ed1e3a2be',
        key: 'ba6db24b4f0b406c939d4963eb7688b5',
        nowWeather: {},
        weatherIcon: {
          100: amQing,
          101: amDuoyun,
          102: amDuoyun,
          103: amDuoyun,
          104: yin,
          150: pmQing,
          151: pmDuoyun,
          152: pmDuoyun,
          153: pmDuoyun,
          300: rain16,
          301: rain14,
          302: rain12,
          303: rain12,
          304: rain13,
          305: rain2,
          306: rain3,
          307: rain4,
          308: rain5,
          309: rain1,
          310: rain6,
          311: rain6,
          312: rain6,
          313: rain2,
          314: rain2,
          315: rain3,
          316: rain4,
          317: rain5,
          318: rain6,
          350: rain11,
          351: rain11,
          399: rain3,
          400: snow1,
          401: snow2,
          402: snow3,
          403: snow4,
          404: rain3,
          405: rain3,
          406: rain15,
          407: snow2,
          408: snow1,
          409: snow2,
          410: snow3,
          456: snow5,
          457: snow3,
          499: snow2,
          500: wu,
          501: wu,
          502: mai,
          503: yangsha,
          504: chen,
          507: shachen,
          508: shachen,
          509: wu,
          510: wu,
          511: mai,
          512: mai,
          513: mai,
          514: wu,
          515: wu,
          900: amQing,
          901: yin,
          999: nodata
        },
      }
    },
    components: {
      "agricultural-products": () => import("./components/AgriculturalProducts.vue"),
      "agricultural-rank": () => import("./components/AgriculturalRank.vue"),
      "qa": () => import("./components/QA.vue"),
      "latest-quotation": () => import("./components/LatestQuotation.vue"),
      "library": () => import("./components/Library.vue"),
      "skills-classroom": () => import("./components/SkillsClassroom.vue"),
      "select-box": () => import("../components/common/SelectBox.vue")
    },
    computed: {
      getAll() {
        return this.cdState && this.xdState && this.jsdState
      }
    },
    mounted(){
      autofit.init({
        dh: 1080,
        dw: 1920,
        el: "#app",
        resize: true
      }, false)
      this.$nextTick(() => {
        this.getBazaarDataEvent();
        this.getDate();
        this.getNowTime();
      });
    },
    methods: {
      initMap(callback) {
        let that = this;
        let getItem = this.selItem;
        this.getCurCityData(getItem.name);
        AMap.plugin(
          ["AMap.DistrictSearch", "AMap.MapType", "AMap.CustomLayer"],
          function () {
            let district = new AMap.DistrictSearch({
              extensions: "all",
              level: "province",
            });
            district.search(getItem.name, function (status, result) {
              let bounds = result.districtList[0]?.boundaries;
              let districts = result.districtList[0]?.districtList;
              let mask = [];
              if(bounds?.length){
                for (let i = 0; i < bounds.length; i++) {
                  mask.push([bounds[i]]);
                };
              };
              let myChart = echarts.init(document.getElementById("mapData"));
              let option = {
                animation: false,
                amap: {
                  mask: mask,
                  center: getItem.center,
                  viewMode: "3D",
                  zoom: getItem.zIndex || 9.2,
                  defaultCursor: "auto",
                },
                series: [],
              };
              myChart.setOption(option);
              let map = myChart.getModel().getComponent("amap").getAMap();
              let mapType = new AMap.MapType({
                defaultType: 1,
                showTraffic: true,
                showRoad: true
              });
              map.addControl(mapType);
              mapType.hide();
              // 省会名字
              let LabelsData = [];
              if(districts?.length){
                for (let i = 0; i < districts.length; i++) {
                  let config = {
                    name: "",
                    zooms: [4, 13],
                    zIndex: 1,
                    opacity: 1,
                    text: {
                      content: "",
                      direction: "center",
                      offset: [0, 0],
                      zooms: [3, 20],
                      style: {
                        fontSize: 12,
                        fontWeight: "normal",
                        fillColor: "#fff",
                        strokeColor: "rgba(0,0,0,1)",
                        strokeWidth: 1,
                      },
                    },
                  };
                  let district = districts[i];
                  let name = district.name;
                  config.text.content = name;
                  config.position = [district.center.lng, district.center.lat];
                  LabelsData.push(config);
                  let district2 = new AMap.DistrictSearch({
                    extensions: "all",
                    level: "city",
                  });
                  if(bounds?.length){
                    district2.search(name, function (status, result) {
                      for (let ii = 0; ii < bounds.length; ii++) {
                        new AMap.Polyline({
                          map: map,
                          path: bounds[ii],
                          strokeColor: "#2687D0",
                          strokeWeight: 2,
                        });
                      }
                    });
                  }
                };
              };
              // 省会边界
              if(bounds?.length){
                for (let i = 0; i < bounds.length; i++) {
                  new AMap.Polyline({
                    map: map,
                    path: bounds[i],
                    strokeColor: "#2687D0",
                    strokeWeight: 6,
                  });
                };
              };
              map.on("complete", function () {
                that.setMapBg();
                that.mapObj = map;
                if(typeof callback === 'function'){
                  callback();
                };
                let layer = new AMap.LabelsLayer({
                  collision: false,
                  animation: false,
                });
                // 省会名称绘制
                for (let i = 0; i < LabelsData.length; i++) {
                  let labelsMarker = new AMap.LabelMarker(LabelsData[i]);
                  layer.add(labelsMarker);
                };
                map.add(layer);
              });
            });
          }
        );
      },
      // 地图背景透明设置
      setMapBg() {
        let timer = null;
        let ele = document.getElementsByClassName("amap-container");
        if(ele?.length){
          timer && clearInterval(timer);
          ele[0].style.background = "none";
          timer = null;
        } else {
          timer = setInterval(() => {
            this.setMapBg();
          }, 1000);
        }
      },
      // 清除marker
      removeMarker(){
        this.markers.forEach(marker => {
          this.mapObj.remove(marker);
        });
        this.markers = [];
      },
      switchState(type) {
        const methods = {
          1: () => {
            this.xdState = false;
            this.jsdState = false;
            if(!this.cdState){
              this.cdState = true;
            };
            this.getBazaarDataEvent();
          },
          2: () => {
            this.cdState = false;
            this.jsdState = false;
            if(!this.xdState){
              this.xdState = true;
            };
            this.getBazaarDataEvent();
          },
          3: () => {
            this.xdState = false;
            this.cdState = false;
            if(!this.jsdState){
              this.jsdState = true;
            };
            this.getBazaarDataEvent();
          },
          4: () => {
            if(!this.getAll){
              this.cdState = true;
              this.xdState = true;
              this.jsdState = true;
              this.getBazaarDataEvent();
            } else {
              this.cdState = false;
              this.xdState = false;
              this.jsdState = false;
              this.removeMarker();
            }
          }
        };
        methods[type] && methods[type]();
      },
      getState(){
        if(this.getAll){
          return '';
        } else if(this.cdState) {
          return 0;
        } else if(this.xdState) {
          return 1;
        } else if(this.jsdState) {
          return 2;
        };
      },
      // 批发市场地图展示
      getBazaarDataEvent() {
        getBazaarData({
          productionMarketingType: this.getState(),
          code: this.selItem?.code || ''
        }).then((res) => {
          const result = this.findDuplicates(JSON.parse(res.data) || []);
          let count = {};
          const state = this.getAll || this.cdState || this.xdState || this.jsdState;
          if(this.createMapItem.code !== this.selItem?.code || !this.mapObj){
            this.createMapItem = this.selItem;
            this.removeMarker();
            this.mapKey = new Date().getTime();
            this.initMap(() => {
              for(let i=0;i<result.length;i++){
                const item = result[i];
                if(item){
                  if(!count[item.productionMarketingType]){
                    count[item.productionMarketingType] = 0;
                  };
                  count[item.productionMarketingType]++;
                  if(state){
                    this.addMarkerFn(item);
                  }
                }
              };
              this.showDNum = count;
            });
          } else {
            this.removeMarker();
            for(let i=0;i<result.length;i++){
              const item = result[i];
              if(item){
                if(!count[item.productionMarketingType]){
                  count[item.productionMarketingType] = 0;
                };
                count[item.productionMarketingType]++;
                if(state){
                  this.addMarkerFn(item);
                }
              }
            };
            this.showDNum = count;
          };
        })
      },
      // 找出数组中重复的元素
      findDuplicates(arr) {  
        let result = [];
        let map = {};
        for(let i=0;i<arr.length;i++){
          const item = arr[i] ? JSON.parse(arr[i]) : '';
          if(item){
            let state = result.some((v) => v.longitude == item.longitude && v.latitude == item.latitude);
            if(state){
              if(map[`${item.longitude}-${item.latitude}`]){
                map[`${item.longitude}-${item.latitude}`]++;
              } else {
                map[`${item.longitude}-${item.latitude}`] = 1;
              };
              item['offsetLeft'] = map[`${item.longitude}-${item.latitude}`]*30;
              item['offsetTop'] = map[`${item.longitude}-${item.latitude}`]*40;
            };
            result.push(item);
          };
        };
        return result;
      },
      // 添加marker
      addMarkerFn(item) {
        const type = {
          0: mapTagCd,
          1: mapTagXd,
          2: mapTagJsd
        };
        const typeIcon = {
          0: chandi,
          1: xiaodi,
          2: jisandi
        };
        const typeColor = {
          0: {
            bc: '#5DDFB3',
            bg1: 'linear-gradient(180deg, rgba(22,156,116,0.4) 0%, #125843 100%)',
            bg2: 'rgba(3,32,23,0.7)'
          },
          1: {
            bc: '#DEC76B',
            bg1: 'linear-gradient(180deg, rgba(161,136,26,0.4) 0%, #635516 100%)',
            bg2: 'rgba(39,32,2,0.7)'
          },
          2: {
            bc: '#D97A5D',
            bg1: 'linear-gradient(180deg, rgba(174,64,28,0.4) 0%, #4E2011 100%)',
            bg2: 'rgba(25,7,2,0.7)'
          }
        };
        if(!item.longitude || !item.latitude || !item.productionMarketingType || !type[item.productionMarketingType]){
          return;
        };
        let markerContent = this.setMarkerStyle({
          img: type[item.productionMarketingType],
          icon: typeIcon[item.productionMarketingType],
          txt: item.marketName || '--',
          sty: typeColor[item.productionMarketingType]
        });
        var marker = new AMap.Marker({
          position: [+item.longitude, +item.latitude],
          content: markerContent,
          offset: new AMap.Pixel(item.offsetLeft || 0, item.offsetTop || 0),
        });
        this.markers.push(marker);
        this.mapObj.add(marker);
      },
      // marker样式设置
      setMarkerStyle(item) {
        return  `
          <div style="position: relative;width: 40px;height: 52px;">
            <img style="
              width: 40px;
              height: 52px;
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              z-index: 0"
              src=${item.img} />
            <div style="
              position: absolute;
              top: -32px;
              left: 50%;
              transform: translateX(-50%);
              display: flex;
              align-items: center;
              height: 32px;
              background: ${item.sty.bg2};
              border: 1px solid ${item.sty.bc};
              padding: 0 20px 0 42px;
              font-size: 14px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 14px;">
                <div style="
                  position: absolute;
                  left: 0;
                  top: 0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 32px;
                  height: 30px;
                  border-right: 1px solid ${item.sty.bc};
                  background: ${item.sty.bg1};
                ">
                  <img style="
                      width: 20px;
                      height: 20px;
                    "
                    src=${item.icon} />
                </div>
                <span>${item.txt}</span>
            </div>
          </div>
        `;
      },
      // 获取当前时间
      getNowTime() {
        this.timer = setInterval(() => {
          const date = new Date();
          const s = date.getSeconds(),
          m = date.getMinutes(),
          h = date.getHours();
          this.timeStr = `${this.dbNum(h)}:${this.dbNum(m)}:${this.dbNum(s)}`;
        }, 1000);
      },
      dbNum(num) {
        return num > 9 ? num : '0'+num;
      },
      // 获取年月日
      getDate() {
        const date = new Date();
        const y = date.getFullYear(),
          M = date.getMonth() + 1,
          d = date.getDate(),
          day = date.getDay();
        this.dateStr = `${y}/${this.dbNum(M)}/${this.dbNum(d)}`;
        const num = ['日','一','二','三','四','五','六']
        this.dayStr = num[day];
      },
      selEvent(data) {
        if(this.selItem?.code === data.code){
          return;
        };
        this.selItem = data;
        this.getBazaarDataEvent();
      },
      closePage() {
        localStorage.removeItem("st");
        window.close();
      },
      getCurCityData(name) {
        fetch(`https://geoapi.qweather.com/v2/city/lookup?location=${name}&key=${this.key}`).then((res) => {
          res.json().then((data) => {
            let item = data.location[0];
            this.getCurWeather(`${item.lon},${item.lat}`);
          })
        })
      },
      getCurWeather(location) {
        fetch(`https://devapi.qweather.com/v7/grid-weather/now?location=${location}&key=${this.key}`).then((res) => {
          res.json().then((data) => {
            const result = data.now || {};
            let date = new Date(result.obsTime);
            let y = date.getFullYear(),
              M = this.dbNum(date.getMonth() + 1),
              d = this.dbNum(date.getDay()),
              h = this.dbNum(date.getHours()),
              m = this.dbNum(date.getMinutes()),
              s = this.dbNum(date.getSeconds());
            result['timeStr'] = `${y}-${M}-${d} ${h}:${m}:${s}`;
            this.nowWeather = result;
          })
        })
      }
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }
</script>
<style scoped lang="less">
@import url("../assets/css/title.less");
  .home {
    width: 100%;
    height: 100%;
    .content {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: calc(100% - 105px);
      padding: 14px 30px;
      overflow: hidden;
      .n-part {
        position: relative;
        width: 440px;
        height: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
        padding: 32px 0 20px 0;
        .mgn-top-70 {
          margin-top: 70px;
        }
      }
      .item2 {
        position: relative;
        width: 1100px;
        height: 100%;
        margin: 0 20px;
        .title-part {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 9;
          width: 100%;
          height: 32px;
          .t-item {
            height: 32px;
            padding: 0 10px;
            background: rgba(49,59,78,0.6);
            font-size: 15px;
            font-weight: 400;
            color: rgba(255,255,255,0.8);
            margin-right: 10px;
            cursor: pointer;
            .i-img {
              width: 16px;
              height: 16px;
              margin-right: 10px;
            }
            .i-num {
              margin-left: 28px;
            }
          }
          .t-select1 {
            position: absolute;
            right: 0;
            top: 0;
            width: 200px;
          }
        }
        .map {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
